import React from 'react'
import { cn } from '@/utils'

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  className?: string
  onValueChange?: (value: string) => void
}

export const Select: React.FC<SelectProps> = ({ 
  className, 
  onValueChange, 
  onChange,
  children,
  ...props 
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (onValueChange) {
      onValueChange(e.target.value)
    }
    if (onChange) {
      onChange(e)
    }
  }

  return (
    <select
      className={cn(
        'flex h-10 w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 px-3 py-2 text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      onChange={handleChange}
      {...props}
    >
      {children}
    </select>
  )
}